import { UserResultRow } from "./UserResultRow";

class TagPassCount {
    constructor(public tag: string, public count: number | undefined) {

    }
}

export class UserResultRowList {

    constructor(public rows: UserResultRow[] = []) {

    }

    getPassCounts(): TagPassCount[] {
        const tags = this.getTags();

        const counts = new Map<string, number>();
        for (const userResult of this.rows) {

            for (const tag of tags) {
                const increment = userResult.getPoints(tag) ? 1 : 0;

                const count = counts.get(tag) || 0;

                counts.set(tag, count + increment);
            }

        }

        return Array.from(counts.keys()).map(
            tag => new TagPassCount(tag, counts.get(tag)));
    }

    getTags(): string[] {
        const user = this.rows.find(e => e.hasResults());

        return user ? user.getTags() : [];
    }

}

